import { messageQueryKey } from "@apis:message/message";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

export const useNewChat = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const newChat = () => {
    // because we add conversationId new as draft message in ChatBox.tsx
    // so we need to set the query data to empty array to avoid showing the old messages
    // when navigating to new chat
    queryClient.setQueryData(
      messageQueryKey.getAllMessagesByConversationId({
        conversationId: "new",
      }).queryKey,
      () => [],
    );

    navigate("/app/chat/new", { replace: true });
  };

  return { newChat };
};
